// extracted by mini-css-extract-plugin
module.exports = {"form-input":"Onboarding_form-input__2XHUp","content":"Onboarding_content__3O1xA","sumsubContainer":"Onboarding_sumsubContainer__3ZHpc"};